import React, { useEffect, useState } from 'react';
import { BaseWidget } from 'models/WidgetModel';
import CategoryDataGrid from 'components/CategoryDataGrid/CategoryDataGrid';
import ContextualAnalysisModal from 'components/CategoryMetricsModal/ContextualAnalysisModal';
import ConversationAnalysisModal from 'components/ConversationAnalysis';
import { isConversationAnalysisV2Enabled } from 'components/ConversationAnalysis/shared/featureFlag';
import { useStore as useGlobalStore } from 'store/useGlobalStore';

type DataGridMetricsProps = BaseWidget;

const DataGridMetrics: React.FC<DataGridMetricsProps> = ({ response, options, ...props }) => {
  const [showModal, setShowModal] = useState<boolean>(false);
  const [secondaryCategoryData, setSecondaryCategoryData] = useState<any>();

  const configFlag = useGlobalStore(
    (state) => state.configDashboard.useConversationAnalysisV2 ?? false
  );
  // A localStorage override takes precedence over the config value so the V2
  // experience can be toggled from the browser in any environment.
  const useConversationAnalysisV2 = isConversationAnalysisV2Enabled(configFlag);

  const closeModal = () => {
    setShowModal(false);
    setSecondaryCategoryData(null);
  };

  const handleCategoryChange = (category: any) => {
    setSecondaryCategoryData(category);
  };

  useEffect(() => {
    if (secondaryCategoryData) {
      setShowModal(true);
    }
  }, [secondaryCategoryData]);

  const modalProps = {
    response,
    onChangeCategory: handleCategoryChange,
    secondaryCategory: secondaryCategoryData,
    options,
    modalOpen: showModal,
    onRequestClose: closeModal,
    ...props,
  };

  return (
    <>
      <CategoryDataGrid
        response={response}
        options={options}
        dataOnClick={setSecondaryCategoryData}
        {...props}
      />
      {useConversationAnalysisV2 ? (
        <ConversationAnalysisModal {...modalProps} />
      ) : (
        <ContextualAnalysisModal {...modalProps} />
      )}
    </>
  );
};

export default DataGridMetrics;
